import React from 'react';
import { Card } from 'react-bootstrap';
import CustomerPerformanceGrid from './CustomerPerformanceGrid';

interface CustomerPerformance {
	customer: string;
	customerRegister: string;
	customerCity: string;
	customerState: string;
	customerSituation: string;
	groupers?: SalesPerformance[];
}

interface SalesPerformance {
	groupCode: number;
	groupDescription?: string;
	sold: number;
}

interface Props {
	rows: any[];
}

const CustomerPerformance = ({ rows }: Props) => {
	return (
		<div className="screen">
			{/* @ts-ignore */}
			<Card>
				{/* @ts-ignore */}
				<Card.Body>
					<div style={{ marginTop: '20px', width: '100%' }}>
						{rows?.length ? (
							<CustomerPerformanceGrid rows={rows} />
						) : (
							<CustomerPerformanceGrid rows={[]} />
						)}
					</div>
				</Card.Body>
			</Card>
		</div>
	);
};

export default CustomerPerformance;
